
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProductSearchField extends Vue {
  @Prop({ type: String, default: 'order' })
  type!: 'order' | 'claim';

  search(query: string) {
    this.$store.dispatch(`${this.type}/productSearch`, query);
  }

  beforeDestroy(): void {
    // Empty the search query so results are reset
    this.search('');
  }
}
